export default {"src":"/_next/static/media/healthOutline50_40.683bbcf2.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};